<!--
 * @Author: your name
 * @Date: 2021-05-10 17:25:44
 * @LastEditTime: 2021-05-26 14:41:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/brandContract/component/Invoicedialog.vue
-->
<template>
  <div>
    <!-- 申请开票 -->
    <el-dialog v-if="dialogShow" title="申请开票" :visible.sync="dialogShow">
      <el-form :model="InvoiceForm" ref="InvoiceForm" :rules="rules">
        <el-form-item
          label="签约主体"
          prop="signSubject"
          class="block-form-item w-32"
        >
          <el-input v-model="InvoiceForm.signSubject" disabled></el-input>
        </el-form-item>
        <el-form-item
          label="公司电话"
          prop="companyPhone"
          class="block-form-item w-32"
        >
          <el-input v-model="InvoiceForm.companyPhone" disabled></el-input>
        </el-form-item>
        <el-form-item
          label="公司地址"
          prop="companyAddress"
          class="block-form-item w-32"
        >
          <el-input v-model="InvoiceForm.companyAddress" disabled></el-input>
        </el-form-item>
        <el-form-item
          label="纳税人识别号"
          prop="taxpayerId"
          class="block-form-item w-32"
        >
          <el-input v-model="InvoiceForm.taxpayerId" disabled></el-input>
        </el-form-item>
        <el-form-item
          label="开户行"
          prop="depositBank"
          class="block-form-item w-32"
        >
          <el-input v-model="InvoiceForm.depositBank" disabled></el-input>
        </el-form-item>
        <el-form-item
          label="银行账号"
          prop="bankAccount"
          class="block-form-item w-32"
        >
          <el-input
            v-model="InvoiceForm.bankAccount"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          label="开票金额"
          prop="invoiceMoney"
          class="block-form-item w-32"
        >
          <el-input v-model="InvoiceForm.invoiceMoney"></el-input>
        </el-form-item>
        <el-form-item
          label="发票类型"
          prop="invoiceType"
          class="block-form-item w-32"
        >
          <el-select v-model="InvoiceForm.invoiceType" class="w-100">
             <el-option
              v-for="(item, index) in billingConfig.getConfigList('invoiceType')"
              :label="item.name"
              :value="parseInt(item.id)"
              :key="index"
              :disabled="!item.isEnable" 
            >
              <div style="display: flex;padding:0 10px;justify-content: space-between;">
                <div>{{item.name}}</div>
                <div style="margin-left:15px;">{{item.isEnable?'':'已禁用'}}</div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="开票明细"
          prop="invoiceDetail"
          class="block-form-item w-32"
        >
          <el-select v-model="InvoiceForm.invoiceDetail" class="w-100">
            <el-option
              v-for="(item, index) in billingConfig.getConfigList('invoiceDetail')"
              :label="item.name"
              :value="parseInt(item.id)"
              :key="index"
              :disabled="!item.isEnable"
            >
              <div style="display: flex;padding:0 10px;justify-content: space-between;">
                <div>{{item.name}}</div>
                <div style="margin-left:15px;">{{item.isEnable?'':'已禁用'}}</div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <div style="padding-bottom:10px;">
          剩余可申请开票金额：{{ remainingMoney }}
        </div>
        <el-form-item label="开票主体" prop="finAccountId" class="block-form-item w-32">
          <el-select v-model="InvoiceForm.finAccountId" class="w-100">
            <el-option 
              v-for="(a, index) in yhgAccountList" 
              :key="index" 
              :label="a.name" 
              :value="a.id"
              :disabled="!a.isEnable">
              <div style="display: flex;padding:0 10px;justify-content: space-between;">
                <div>{{a.name}}</div>
                <div style="margin-left:15px;">{{a.isEnable?'':'已禁用'}}</div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="开票备注"
          prop="remark"
          class="block-form-item w-99"
        >
          <el-input placeholder="请输入开票备注" maxlength="300" show-word-limit rows="4" type="textarea" v-model="InvoiceForm.remark"></el-input>
        </el-form-item>
        <div class="mar-c">
          <el-button type="primary" size="small" @click="onSubmit"
            >提交</el-button
          >
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import validate from "@/util/validate";
import { billingConfig,billingShow } from "@/const/config/billing";
import { getFinAccount } from "@/api/business/contract";
export default {
  data() {
    // 开票金额判断
    var validPrice = (rule, value, callback) => {
      let money = this.remainingMoney;
      if (!validate.checkNull(value)) {
        let err = validate.checkAmount(value, money);
        if (err) {
          callback(new Error(err));
        }
        callback();
      }
      callback();
    };
    return {
      dialogShow: false, //开票弹窗
      billingConfig,
      billingShow,
      remainingMoney:0,//开票金额
      InvoiceForm: {
        brandContractId: null, //合同ID
        signSubject: "", //签约主体
        companyPhone: "", //电话
        companyAddress: "", //公司地址
        taxpayerId: "", //纳税人识别号
        depositBank: "", //客户开户行
        bankAccount: "", //客户银行账户
        invoiceMoney: "", //开票金额
        invoiceType: "", //发票类型
        invoiceDetail: "", //开票明细
        remark: "", //合同备注
        finAccountId:"",
      },
      rules: {
        invoiceMoney: [
          { required: true, message: "请输入合同金额", trigger: "blur" },
          { validator: validPrice, trigger: "blur" },
        ],
        invoiceType: [
          { required: true, message: "请选择发票类型", trigger: "change" },
        ],
        invoiceDetail: [
          { required: true, message: "请选择开票明细", trigger: "change" },
        ],
        finAccountId: [
          { required: true, message: "请选择开票主体", trigger: "change" },
        ],
      },
      yhgAccountList:[]
    };
  },
  watch:{
    dialogShow(show){
      if(show){
        this.getYhgAccount()
      }
    }
  },
  methods: {
    //获取有花果账户列表
    getYhgAccount() {
      getFinAccount({type:0})
        .then((res) => {
          this.yhgAccountList = res.data || [];
        })
        .catch((err) => {
          this.yhgAccountList = [];
        });
    },
    //提交
    onSubmit() {
      this.$refs.InvoiceForm.validate((valid, obj) => {
        if (valid) {
          this.$emit('invoiceSubmit',this.InvoiceForm)
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// 列表item
.block-form-item {
  &.w-32 {
    display: inline-block;
    width: 32%;
    margin-right: 1%;
    min-height: 64px;
  }

  &.w-99 {
    width: 99%;
    margin-right: 1%;
  }
}
.mar-c {
  display: flex;
  justify-content: center;
}
</style>